<template>
  <div>
    <div class="header-content" id="dashboard-header">
      <h1>User Management</h1>
    </div>
    <div class="uk-container uk-section">
      <ul class="uk-tab-bottom" uk-tab id="dashboard-tabs">
        <li id='current-user-tab' class="uk-active"><a href="#" @click="userMgmtSection=0;">Active Users From Your
          Organization</a></li>
        <li id='eligible-user-tab' v-show="allowed_invite_employees"><a href="#" @click="demo='eligible-users'; userMgmtSection=1; refreshEligibleInvites">Invite
          Employees to Become Users</a></li>
        <li id='register-employee-tab' v-show="allowed_register_child_employee || allowed_register_any_employee"><a href="#"
                                                                                         @click="userMgmtSection=2; demo='Charts';">Register
          New Employees</a></li>

      </ul>
      <div class="tab-section" v-show="userMgmtSection==0">
        <alert v-show="myOrgUserError" class="uk-alert-danger"
               :data="{title: 'Something went wrong when getting user data. Try Refreshing the Page', body: myOrgUserError, closeable:true}">
        </alert>
        <data-table :data="myOrgUsers" name="Current Users From Your Organization"></data-table>
      </div>
      <div class='tab-section' v-show="userMgmtSection==1">
        <spinner-overlay v-if="showOverlay"/>
        <alert v-show="invite_error" class="uk-alert-danger"
               :data="invite_error"></alert>
        <alert v-show="invite_sent" class="uk-alert-success"
               :data="{title: 'Invite Successfully Sent', body: 'Your invite was successfully sent. You can see which employees were sent in the table below.', closable:true}">
        </alert>
        <alert v-show="specify_position_type" class="uk-alert-success"
               :data="{title:'You can invite anyone', closeable:true, body:'Please specify below the type of employee to look for'}"></alert>
        <alert v-show="editEmployeeSuccess" class="uk-alert-success"
               :data="{title:'Employee was successfully updated', closeable:true}"></alert>
        <alert v-show="editEmployeeError" class="uk-alert-danger"
               :data="{title:'Something went wrong when updating the employee.', closeable:true, body:editEmployeeError}"></alert>
        <FloatFieldInput v-if="specify_position_type"
                         :data="{select: true, label:'Position Type', options:[{display:'Driver', value:'Driver'},{display:'Executive', value:'Executive'},{display:'Station Owner/Supervisor', value:'Station-Manager'}, {display:'Territory Manger', value:'Facility-Rep'} ]}"
                         @inputevent="function(input){specified_position_type=input; refreshEligibleInvites();}"></FloatFieldInput>
        <data-table :data="eligibleInvites" name="Employees You Can Invite (Not Already Users)"
                    @output="processInviteOutput" @action="sendInvite" action_button="Send Invites"
                    @cellAction="editEmployeeRecord"></data-table>
      </div>
      <div class='tab-section' v-show="userMgmtSection==2">
        <alert v-show="Register_employee_error" class="uk-alert-danger"
               :data="{title: 'Something went wrong when submitting', body: Register_employee_error, closeable:true}">
        </alert>
        <alert v-show="Register_employee_success" class="uk-alert-success"
               :data="{title: 'Employee Successfully Registered', body: 'The Employee has been registered and can be invited from the tab --INVITE EMPLOYEES TO BECOME USERS-- at the top!', closable:true}">
        </alert>
        <form-container v-show="!Register_employee_success"
                        form_title="Register New Employee"
                        :fieldList="formFields"
                        :resetSignal="resetSignal"
                        :footer_html="register_employee_hardcode"
                        @output="processRegisterEmployeeFormData" @input="processRegisterEmployeeInput"
        ></form-container>
        <button @click="resetForm" v-show="Register_employee_success" class="uk-button uk-button-primary">Add Another
          Employee
        </button>
        <modal id="edit-cell-record-modal" :resetForm="resetEditEmployeeForm" :data="editEmployeeFormData"
               @formOutput="submitEditEmployee"></modal>

      </div>

    <Demo :showName="demo"></Demo>
    </div>
  </div>
</template>

<script>
	import formContainer from "./theme/formContainer.vue"
	import apiCall from '../store/apicall.js'
	import DataTable from "./theme/DataTable.vue"
	import alert from "./theme/Alert.vue"
	import moment from "moment";
	import FloatFieldInput from "./theme/Input.vue"
	import Modal from "./theme/Modal.vue"
	import editCellRecord from "./theme/editCellRecord"
	import UIkit from 'uikit'; // necessary for intro stuff
    import Demo from "./theme/Demo"

	import SpinnerOverlay from "./theme/SpinnerOverlay.vue"

	function validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	function clean_invite_date(invite_value) {
		if (invite_value == null) {
			return "Not Invited Yet"
		} else {
			return moment(invite_value).format('MM-DD-YYYY')
		}
	}

	function clean_missing_name(name) {
		if (name == null) {
			return "Missing"
		} else {
			return name
		}
	}

	function create_my_org_users_table(_t) {
		console.log("CREATING MY ORG USERS")
		apiCall.post('/accounts/employee/', {'my_org_users': 1}, () => create_my_org_users_table(_t))
        .then(function (response) {
			response.data.forEach(function (el) {
				_t.myOrgUsers.push({
					First_Name: el.first_name,
					Last_Name: el.last_name,
					Username: el.user.username,
					Date_Joined: clean_invite_date(el.user.date_joined),
					Position_Type: el.position_type,
					Dashboard: '/dashboard/' + el.slug
				})
			});
		}).catch(function (error) {
			_t.myOrgUserError = error.response;
			console.log("forcing update");
			_t.$forceUpdate();

		})
	}

	function create_eligible_invites_table(_t) {
		console.log("GETTING ELIGIBLE INVITES")
		apiCall.post('/accounts/invite/', {
			"eligible_employees": 1,
			"only_non_users": 1,
			"position_type": _t.specified_position_type
		}).then(function (response) {
			response.data.forEach(function (el) {
				// console.log(el)
				let row_data = {
					Edit: {
						html: false,
						icon: 'pencil',
						emit_click: true,
						emit_click_name: 'edit',
						emit_value: el.id
					},
					First_Name: clean_missing_name(el.first_name),
					Last_Name: clean_missing_name(el.last_name),
					Organization: el.org_name_help,
					Position_Type: el.position_type,
					Was_Invited: clean_invite_date(el.invited_on),
					Data_ID: el.data_name,
					ID: el.id,
					email: {
						html: false,
						id: el.id,
						input_type: 'email',
						model: 'email',
					},
					send: {
						html: false,
						id: el.id,
						input_type: 'checkbox',
						model: 'send',
					},

				};
				_t.eligibleInvites.push(row_data)
			})
			_t.showOverlay = false;
		})
				.catch((error) => {
					console.log("Error!!!!", error)
							if (error.response.status === 401) {
								// _t.$router.go(0);
							}
						}
				)
	}

	export default {
		name: "UserMGMT",
		components: {
			formContainer,
			DataTable,
			alert,
			FloatFieldInput,
			SpinnerOverlay,
			Modal,
			editCellRecord,
            Demo,
		},
		data: function () {
			return {
			    demo: 'current-users',
				formInput: false,
				userMgmtSection: 0,
				formFields: [
					['first_name'],
					['last_name'],
					['Permissions', {
						'multi-select': []
					}],
					['Position Type', {
						'select': [
							{display: 'Driver', value: 'Driver'}, //Need to make this user permission dependent
							{display: 'Call Center Operator', value: 'Call-Center-Operator'},
							{display: 'Territory Manger', value: 'Facility-Rep'},
							{display: 'Call Center Dispatcher', value: 'Call-Center-Dispatcher'},
							{display: 'Territory Associate', value: 'Territory-Associate'},
							{display: 'Station Owner/Supervisor/Admin', value: 'Station-Admin'},
							{display: 'Executive/Analyst', value: 'Executive'}]
					}],
				],
				resetSignal: false,
				success_message: "Employee Registered. Do you want to Register Another?",
				Register_employee_success: false,
				Register_employee_error: false,
				submitted: false,
				invite_error: false,
				invite_info: false,
				invite_code: false,
				error: false,
				// newEmployeeData: [],
				eligibleInvites: [],
				myOrgUsers: [],
				formOutput: [],
				invite_sent: false,
				allowed_register_child_employee: false,
				allowed_register_any_employee: false,
				allowed_invite_employees: false,
				register_employee_from_org: null,
				register_employee_from_org_type: null,
				register_employee_from_org_name: "",
				myOrgUserError: false,
				register_employee_hardcode: "",
				register_employee_hardcode_id: null,
				specify_position_type: false,
				specified_position_type: "Executive",
				showOverlay: false,
				toEditEmployee: {},
				toEditEmployeeClean: "",
				editEmployeeSuccess: false,
				editEmployeeError: false,
				resetEditEmployeeForm: false,
				editEmployeeFormData: {}

			}
		},
		mounted() {
			let _t = this;

			let user_permissions = this.$store.state.user.data.permission
			user_permissions.forEach(function (el) {
				_t.formFields[2][1]['multi-select'].push({
					label: el.explanation,
					value: el.id
				})

				if (el.name.split('-')[0] == 'invite') {
					_t.allowed_invite_employees = true
				}

				if (el.name == 'invite-anyone') {
					_t.specify_position_type = true
				}

				if (el.name == 'create-child-employees') {
					_t.allowed_register_child_employee = true;
					_t.register_employee_from_org = _t.$store.state.user.data.organization
					_t.register_employee_from_org_type = _t.$store.state.user.data.organization.type
					_t.register_employee_from_org_name = _t.$store.state.user.data.organization.name
				}

				if (el.name == 'create-employee') {
					_t.allowed_register_child_employee = true
					_t.allowed_register_any_employee = true

				}

			});

			create_my_org_users_table(_t);

			create_eligible_invites_table(_t)


		},
		methods: {
			refreshEligibleInvites: function () {
				this.showOverlay = true;
				this.userMgmtSection = 1;
				let _t = this;
				_t.eligibleInvites = [];
				create_eligible_invites_table(_t)
			},
			processInviteOutput: function (output) {
				let _t = this;
				for (let i = 0; i < _t.formOutput.length; i++) {
					if (output.id == _t.formOutput[i].id) {
						_t.formOutput[i][output.type] = output.data;
						return true
					}
				}
				let output_dict = {id: output.id, checkbox: false}
				output_dict[output.type] = output.data;
				_t.formOutput.push(output_dict);
				// console.log(_t.formOutput)
			},
			editEmployeeRecord: function (val) {
				// console.log("EDIT EMPLOYEE RECORD", val)
				this.editEmployeeError = false;
				this.editEmployeeSuccess = false;
				let _t = this
				this.eligibleInvites.forEach(function (el) {
					if (el.ID == val) {
						_t.toEditEmployee = el
						_t.toEditEmployeeClean = "<h3>Current Information</h3><p>First Name: " + el.First_Name + "</p>"
						_t.toEditEmployeeClean += "<p>Last Name: " + el.Last_Name + "</p>"
					}
				});

				_t.editEmployeeFormData = {
					form: true,
					formFields: [['first_name'], ['last_name']],
					formTitle: 'Edit Employee',
					html: _t.toEditEmployeeClean
				}

				UIkit.modal('#edit-cell-record-modal').show();
			},
			submitEditEmployee: function (output) {
				UIkit.modal('#edit-cell-record-modal').hide();
				output['employee_id'] = this.toEditEmployee.ID;
				output['edit_info'] = 1;
				console.log(output);
				let _t = this;
				apiCall.post('/accounts/employee/', output).then(function () {
					_t.editEmployeeSuccess = true;
					_t.eligibleInvites = [];
					create_eligible_invites_table(_t)
					_t.resetEditEmployeeForm = true;
					console.log("RESETTING FORM!")
					// _t.resetEditEmployeeForm = false;
				}).catch(function (error) {
					console.log(error);
					_t.editEmployeeError = error;
				})
			},
			resetForm: function () {
				this.formFields = this.formFields.slice(0, 4)
				this.resetSignal = true
				this.Register_employee_success = false;
			},
			sendInvite: function () {
				console.log("SENDING INVITE")
				let _t = this;
				let submit_this = []
				_t.invite_error = false
				for (let i = 0; i < _t.formOutput.length; i++) {
					if (_t.formOutput[i].checkbox) {
						if (validateEmail(_t.formOutput[i]['email'])) {
							submit_this.push({
								employee: _t.formOutput[i]['id'],
								email: _t.formOutput[i]['email']
							})
						} else {
							_t.invite_error = {
								title: 'Email Is not Valid',
								body: _t.formOutput[i]['email'] + " IS NOT VALID!",
								icon: 'warning'
							}
						}

					}
				}
				if (!_t.invite_error) {
					console.log("SUCCESS")
					console.log(submit_this);
					_t.invite_sent = false;
					apiCall.post('/accounts/invite/', submit_this).then(function (response) {
						console.log(response);
						_t.invite_sent = true;
						submit_this.forEach(function (st) {
							for (let i = 0; i < _t.eligibleInvites.length; i++) {
								if (_t.eligibleInvites[i].ID == st.employee) {
									_t.eligibleInvites[i].Was_Invited = moment().format("MM-DD-YYYY");
									_t.eligibleInvites[i].email = st.email
									_t.eligibleInvites[i].send = "<span class=\"uk-margin-small-right\" uk-icon=\"icon: check\"></span>"

								}
							}
						})
					}).catch(function (error) {
						_t.invite_error = {
							title: 'Something went wrong when submitting',
							body: "ERROR INFO: " + error,
							icon: 'warning'
						}
					})


				}
			},
			processRegisterEmployeeFormData: function (output) {
				console.log(output)

				let org_key = this.formFields[this.formFields.length - 1][0];
				let submit_this = [];
				let org_id = null;
				if (this.register_employee_hardcode_id) {
					org_id = this.register_employee_hardcode_id;
				} else {
					org_id = output[org_key];
				}

				submit_this.push({
					organization: org_id,
					first_name: output['first_name'],
					last_name: output['last_name'],
					position_type: output['Position Type'],
					permission: output['Permissions']
				})
				let _t = this
				console.log("SUBMIT THIS", submit_this)
				apiCall.post('/accounts/employee/', submit_this).then(function (response) {
					console.log("NEW EMPLOYEE RESPONSE", response)
					_t.Register_employee_success = true
				}).catch(function (error) {
					// console.log(error)
					_t.Register_employee_error = error;
				})
			},
			processRegisterEmployeeInput: function (input) {
				// console.log("INPUT", input)
				let roadside_types = ['Driver', 'Station-Manager', 'Facility-Rep', 'Territory-Associate'];
				let call_center_types = ['Call-Center-Operator', 'Call-Center-Dispatcher']
				let eligible_register_org_types = ['Market', 'Territory', null]


				function drilldown(top, bottom, input, _t) {
					// console.log(input[1][top])
					let position_type = input[1]['Position Type']
					if (position_type == 'Territory-Associate' && bottom == 'Station-Business') {
						return false
					}
					if (position_type == 'Facility-Rep' && bottom == 'Station-Business') {
						return false
					}
					if (position_type == 'Call-Center-Dispatcher') {
						return false
					}
					if (input[0] == top) {
						let newField = [bottom, {'select': []}];
						apiCall.post('/accounts/organizations/', {
							"vertical": "roadside",
							"relation": "children",
							"org_id": input[1][top]
						}).then(function (response) {
							response.data.forEach(function (item) {
								newField[1]['select'].push({'display': item['display_name'], 'value': item['id']})
							})
							_t.formFields.push(newField)
						})
					}
				}

				if (eligible_register_org_types.includes(this.register_employee_from_org_type)) {
					if (input[0] == 'Position Type' && roadside_types.includes(input[1]['Position Type'])) {
						if (this.formFields.length > 3) {
							this.formFields = this.formFields.slice(0, 4)//TODO: something buggy here when we reset the form!
						}
						let newField = ['Market', {'select': []}];
						let _t = this
						apiCall.post('/accounts/organizations/', {
							"vertical": "roadside",
							"relation": "children",
							"org_id": _t.register_employee_from_org
						}).then(function (response) {
							response.data.forEach(function (item) {
								newField[1]['select'].push({'display': item['display_name'], 'value': item['id']})
							})
							_t.formFields.push(newField)
						})
					} else if (input[0] == 'Position Type' && call_center_types.includes(input[1]['Position Type'])) {
						let newField = ['Call Center', {'select': []}];
						let _t = this;
						apiCall.post('/accounts/organizations/', {
							"vertical": "call-center",
							"relation": "children",
							"org_id": _t.register_employee_from_org
						}).then(function (response) {
							response.data.forEach(function (item) {
								newField[1]['select'].push({'display': item['display_name'], 'value': item['id']})
							})
							_t.formFields.push(newField)
						})
					}
					let _t = this
					drilldown('Market', 'Territory', input, _t);
					drilldown('Territory', 'Station-Business', input, _t);
					drilldown('Call Center', 'Call-Center-Group', input, _t); //TODO: this doesnt work yet
				} else {
					this.register_employee_hardcode = "<h3>ORGANIZATION: " + this.register_employee_from_org_name + "</h3>"
					this.register_employee_hardcode_id = this.register_employee_from_org.id;

				}


			},

		},
	}
</script>

<style lang="less" scoped>
  .uk-button {
    margin-top: 10px;
  }
</style>
